// Grab gate for handles with `touch-action: pan-y`: a vertical finger drag belongs to native
// scroll (the browser pans and fires pointercancel), so a touch grab only starts when the
// browser has not taken the gesture and the drag so far is horizontal-dominant. Mouse/pen and
// `touch-action: none` handles always grab.
export function mayGrab(pointerType: string, touchAction: string, dx: number, dy: number, cancelled: boolean): boolean {
  if (pointerType !== 'touch') return true;
  if (cancelled) return false;
  if (touchAction !== 'pan-y') return true;
  return Math.abs(dx) > Math.abs(dy);
}
